import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Link
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Error, Cancel, Done, DoneAll, SpeakerNotesOff, Info } from '@material-ui/icons';
import DescriptionList from './DescriptionList';
import Moment from 'react-moment';
import PropTypes from 'prop-types';
import { CONSTANTS } from '../../../../../constants/constants';

const useStyles = makeStyles((theme) => ({
  listItem: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default
    }
  },
  iconButton: {
    [theme.breakpoints.down(990)]: {
      marginRight: '10px',
      '& span span svg': {
        fontSize: '1.3rem'
      }
    }
  },
  red: {
    backgroundColor: '#B00020'
  },
  green: {
    backgroundColor: '#0DC599'
  } }));

const ListItemAvatarCustom = ({ currentStatus, documentStatus }) => {
  const classes = useStyles();
  if (currentStatus === CONSTANTS.STEP.STATUS.ERROR) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <Error />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.STEP.STATUS.CANCELLED && documentStatus === CONSTANTS.DOCUMENT.STATUS.CANCELLED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <Cancel />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.STEP.STATUS.REJECTED && documentStatus === CONSTANTS.DOCUMENT.STATUS.REJECTED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <SpeakerNotesOff />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.STEP.STATUS.EXPIRED && documentStatus === CONSTANTS.DOCUMENT.STATUS.EXPIRED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.red}>
          <SpeakerNotesOff />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.STEP.STATUS.SIGNED && documentStatus === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green}>
          <Done />
        </Avatar>
      </ListItemAvatar>
    );
  } else if (currentStatus === CONSTANTS.STEP.STATUS.SIGNED && documentStatus === CONSTANTS.DOCUMENT.STATUS.SIGNED) {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green} >
          <DoneAll />
        </Avatar>
      </ListItemAvatar>
    );
  } else {
    return (
      <ListItemAvatar>
        <Avatar className={classes.green}>
          <Info />
        </Avatar>
      </ListItemAvatar>
    );
  }
};

const DocumentItem = ({ notif, markAsRead, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const currentStatus = data.step ? data.step.status : undefined;
  const currentStepType = data.step ? data.step.type : undefined;
  const documentStatus = data.document.status;
  const documentName = data.document.name;
  const documentId = data.document.id;
  /*eslint-disable*/
  return (
    <ListItem
      alignItems='flex-start'
      onClick={markAsRead.bind(null, notif.id)}
      key={notif.id}
      divider
      className={classes.listItem}
    >
      <ListItemAvatarCustom
        currentStatus={currentStatus}
        documentStatus={documentStatus}
      />
      <ListItemText
        primary={documentName}
        secondary={
          <React.Fragment>
            <DescriptionList
              notif={notif}
              currentStatus={currentStatus}
              documentStatus={documentStatus}
              documentName={documentName}
              currentStepType={currentStepType}
            />
                <>
                  <br />
                  <Link
                    href={`/document/detail/${documentId}`}
                    target='_blank'
                    style={{
                      color: 'rgba(0, 174, 183, 0.87)',
                      fontSize: 16,
                      fontFamily: 'Roboto-Regular',
                      fontWeight: 600,
                      letterSpacing: '0.5px'
                    }}
                  >
                    {t('notification:view')}
                  </Link>
                  </>
            <br />
            <Moment
                  format='DD/MM/YYYY HH:mm:ss'
                  style={{ fontSize: '0.8em' }}
                >
                  {notif.createdAt}
                </Moment>
          </React.Fragment>
        }
      />
    </ListItem>
  );
  /* eslint-enable */
};

DocumentItem.propTypes = {
  notif: PropTypes.object,
  markAsRead: PropTypes.func,
  data: PropTypes.object
};

export default DocumentItem;
